module.exports = __webpack_public_path__ + "media/svg-new/022-right-0242b02a.svg";